// eslint-disable-next-line no-unused-vars
import { CareerAndSeasonStatsState } from '../types';
import '../../types';

/**
 * @param {CareerAndSeasonStatsState} draft - Draft state.
 * @param {object} payload - Action payload.
 */
export const setCareerAndSeasonStats = (
    draft,
    {
        yearlySeasonStats
    }
) => {
    draft.data.yearly = yearlySeasonStats;
};